export const isPreviewPage = () => window.location.pathname.includes('preview');
